class MathProportionCalculator {
    static percentage({ value, from }) {
        return (value * 100) / from;
    }
}

export { MathProportionCalculator as M };
//# sourceMappingURL=mathProportionCalculator-1f90427a.js.map
